import styled from 'styled-components';

/*
====================
Steps Section
====================
 */
export const StepsWrapper = styled.div`
  padding-bottom: 80px;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
  }
`;

export const StepsButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  a:first-child {
    margin-bottom: 24px;
  }
`;

export const CardsWrapper = styled.div`
  padding: 48px 0 64px;
  display: flex;
  justify-content: center;
  gap: 24px;
  width: 920px;
  margin: 0 auto;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    flex-direction: column;
    width: 288px;
  }
`;

const cardPadding = '32px';

export const Card = styled.div`
  display: flex;
  text-align: left;
  padding: ${cardPadding};
  border-radius: 12px;
  flex-grow: 1;
  position: relative;
  padding-top: calc(90px + ${cardPadding} + 24px);
  background: ${({
    theme: {
      colors: {
        functional: { white },
      },
    },
  }) => white};
  box-shadow: ${({
    theme: {
      boxShadow: { blue },
    },
  }) => blue};
  p {
    margin-bottom: 0;
  }
  h1 {
    color: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
    margin-right: 16px;
  }
`;

export const CardImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - ${cardPadding} - ${cardPadding});
  height: 90px;
  position: absolute;
  left: ${cardPadding};
  top: ${cardPadding};
  right: ${cardPadding};
  img {
    max-height: 90px;
  }
  svg {
    width: 90px;
    max-height: 80px;
  }
`;
